/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：MNNq
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "courseDialog": "courseDialog_Pcsqd",
  "courseList": "courseList_3Q8En",
  "courseItem": "courseItem_2ZgsJ",
  "courseImage": "courseImage_2_kOH",
  "image": "image_nRm-m",
  "mask": "mask_2tBZj",
  "playBox": "playBox_-k79s",
  "courseName": "courseName_iqtM_",
  "courseDesc": "courseDesc_Aojpr",
  "courseMore": "courseMore_2m26I",
  "moreImage": "moreImage_3c8ZE",
  "moreTips": "moreTips_11GMJ"
}

/***/
